import { render } from "./NFLTotals.vue?vue&type=template&id=09a3d68e"
import script from "./NFLTotals.vue?vue&type=script&lang=js"
export * from "./NFLTotals.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/ff-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__